import { DataActiveStatusEnum } from "../../Category/types";
import { IData, ProductRetailerState } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  title: "",
  price: "",
  taxRate: "",
  sellingPrice: "",
  images: [],
  status: DataActiveStatusEnum.ACTIVE,
  shipmentCapacity: "",
  allergicImages: [],
  stickers: [],
  categoryId: "",
  featuredImage: [],
  shortDescription: "",
  longDescription: "",
  code: "",
  size: "",
  categoryTitle: ""
};

export const initialState: ProductRetailerState = {
  formData: {
    ...defaultFormData,
  },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  excelList: [],
  excelDetailsList: []
};
